import flowerWatermark from "@/assets/flower-watermark.svg";

export function Flower({ className = "" }: { className?: string }) {
  return (
    <img
      src={flowerWatermark}
      alt="Virginia Bariatric Surgery decorative flower accent"
      loading="lazy"
      decoding="async"
      className={`pointer-events-none absolute select-none ${className}`}
    />
  );
}
